import React from 'react';
import { useStyles, listTextStyles } from './Invoice.styled';
import { Box, List, ListItem, ListItemText } from '@material-ui/core';

const InvoiceCard = ({ list }) => {
  const classes = useStyles();
  const listClasses = listTextStyles();

  return (
    <Box className={classes.invoiceCardContainer}>
      <List className={classes.list}>
        {list.map((val, index) => (
          <ListItem key={index} className={classes.listItem}>
            <ListItemText primary={val.label} secondary={val.value} classes={listClasses} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default InvoiceCard;
